/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../banking/common';
import './model';
import '../common/time';
import '../connect/v2/resources/error';
import '../connect/v2/common/money';
import '../merchantein/merchant/merchant';
import '../common/currency';
import '../bizbank/service';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "balancereporter": {
        "nested": {
          "service": {
            "nested": {
              "GetBalanceReportRequest": {
                "fields": {
                  "owners": {
                    "type": ".squareup.banking.Owner",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "activityStateCategory": {
                    "type": ".squareup.balancereporter.BalanceReportItemStateCategory",
                    "id": 2,
                    "rule": "optional"
                  },
                  "filters": {
                    "type": ".squareup.balancereporter.service.GetBalanceReportRequest.Filters",
                    "id": 3,
                    "rule": "optional"
                  },
                  "batchRequest": {
                    "type": ".squareup.balancereporter.service.GetBalanceReportRequest.BatchRequest",
                    "id": 4,
                    "rule": "optional"
                  },
                  "clientCurrentTime": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 5,
                    "rule": "optional"
                  },
                  "reportAccountId": {
                    "type": ".squareup.balancereporter.ReportAccountId",
                    "id": 6,
                    "rule": "optional"
                  },
                  "includeCurrencyConversionRates": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional"
                  },
                  "activityStateRequestType": {
                    "type": ".squareup.balancereporter.ActivityStateRequestType",
                    "id": 8,
                    "rule": "optional",
                    "options": {
                      "default": "USE_ACTIVITY_STATE_CATEGORY"
                    }
                  }
                },
                "nested": {
                  "Filters": {
                    "fields": {
                      "includeBalanceItemTypeCategories": {
                        "type": ".squareup.balancereporter.BalanceReportItemTypeCategory",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "minActivityOccurredAt": {
                        "type": ".squareup.common.time.DateTime",
                        "id": 2,
                        "rule": "optional"
                      },
                      "maxActivityOccurredAt": {
                        "type": ".squareup.common.time.DateTime",
                        "id": 3,
                        "rule": "optional"
                      },
                      "excludeNonDisputable": {
                        "type": "bool",
                        "id": 4,
                        "rule": "optional"
                      }
                    }
                  },
                  "BatchRequest": {
                    "fields": {
                      "batchToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "batchSize": {
                        "type": "int32",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "GetBalanceReportResponse": {
                "fields": {
                  "balanceReportLineItems": {
                    "type": ".squareup.balancereporter.service.GetBalanceReportResponse.BalanceReportLineItem",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "paginationToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "hasHiddenBalanceReportItems": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 4,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "BalanceReportBundle": {
                    "fields": {
                      "displayData": {
                        "type": ".squareup.balancereporter.service.GetBalanceReportResponse.BalanceReportBundle.DisplayData",
                        "id": 1,
                        "rule": "optional"
                      },
                      "balanceReportItems": {
                        "type": ".squareup.balancereporter.BalanceReportItem",
                        "id": 2,
                        "rule": "repeated"
                      },
                      "id": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "DisplayData": {
                        "fields": {
                          "title": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "description": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "displayDate": {
                            "type": ".squareup.common.time.DateTime",
                            "id": 3,
                            "rule": "optional"
                          },
                          "amount": {
                            "type": ".squareup.connect.v2.common.Money",
                            "id": 4,
                            "rule": "optional"
                          },
                          "balance": {
                            "type": ".squareup.connect.v2.common.Money",
                            "id": 5,
                            "rule": "optional"
                          },
                          "image": {
                            "type": ".squareup.balancereporter.BalanceReportItemImage",
                            "id": 6,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  },
                  "BalanceReportLineItem": {
                    "fields": {
                      "balanceReportItemBundle": {
                        "type": ".squareup.balancereporter.service.GetBalanceReportResponse.BalanceReportBundle",
                        "id": 1
                      },
                      "balanceReportItem": {
                        "type": ".squareup.balancereporter.BalanceReportItem",
                        "id": 2
                      }
                    },
                    "nested": {
                      "line_item": {
                        "oneof": ["balanceReportItemBundle", "balanceReportItem"]
                      }
                    }
                  }
                }
              },
              "GetBalanceReportItemDetailsRequest": {
                "fields": {
                  "balanceReportItemId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "clientCurrentTime": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "GetBalanceReportItemDetailsResponse": {
                "fields": {
                  "detail": {
                    "type": ".squareup.balancereporter.BalanceReportItemDetail",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetBalanceOverviewRequest": {
                "fields": {
                  "owner": {
                    "type": ".squareup.banking.Owner",
                    "id": 1,
                    "rule": "optional"
                  },
                  "overviewType": {
                    "type": ".squareup.balancereporter.BalanceOverviewType",
                    "id": 2,
                    "rule": "optional"
                  },
                  "filters": {
                    "type": ".squareup.balancereporter.service.GetBalanceOverviewRequest.Filters",
                    "id": 3,
                    "rule": "optional"
                  },
                  "reportAccountId": {
                    "type": ".squareup.balancereporter.ReportAccountId",
                    "id": 4,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Filters": {
                    "fields": {
                      "beginAt": {
                        "type": ".squareup.common.time.DateTime",
                        "id": 1,
                        "rule": "optional"
                      },
                      "endAt": {
                        "type": ".squareup.common.time.DateTime",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "GetBalanceOverviewResponse": {
                "fields": {
                  "balanceOverview": {
                    "type": ".squareup.balancereporter.BalanceOverview",
                    "id": 1
                  },
                  "errorMessage": {
                    "type": "string",
                    "id": 2
                  }
                },
                "nested": {
                  "result": {
                    "oneof": ["balanceOverview", "errorMessage"]
                  }
                }
              },
              "BackfillMerchanteinMerchantsRequest": {
                "fields": {
                  "merchants": {
                    "type": ".squareup.balancereporter.service.BackfillMerchanteinMerchantsRequest.VersionedMerchant",
                    "id": 1,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "VersionedMerchant": {
                    "fields": {
                      "version": {
                        "type": "int64",
                        "id": 1,
                        "rule": "optional"
                      },
                      "merchant": {
                        "type": ".squareup.merchantein.merchant.Merchant",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "BackfillMerchanteinMerchantsResponse": {
                "fields": {}
              },
              "SumUnitDebitCardSpendRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "beginAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 2,
                    "rule": "optional"
                  },
                  "endAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 3,
                    "rule": "optional"
                  },
                  "reportAccountId": {
                    "type": ".squareup.balancereporter.ReportAccountId",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "SumUnitDebitCardSpendResponse": {
                "fields": {
                  "amount": {
                    "type": ".squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetBalanceSnapshotRequest": {
                "fields": {
                  "balanceSnapshotType": {
                    "type": ".squareup.balancereporter.BalanceSnapshot.BalanceSnapshotType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "reportAccountId": {
                    "type": ".squareup.balancereporter.ReportAccountId",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "GetBalanceSnapshotResponse": {
                "fields": {
                  "response": {
                    "type": ".squareup.balancereporter.service.GetBalanceSnapshotResponse.Response",
                    "id": 1
                  },
                  "errorMessage": {
                    "type": "string",
                    "id": 2
                  }
                },
                "nested": {
                  "Response": {
                    "fields": {
                      "balanceSnapshot": {
                        "type": ".squareup.balancereporter.BalanceSnapshot",
                        "id": 1,
                        "rule": "optional"
                      },
                      "reportAccountId": {
                        "type": ".squareup.balancereporter.ReportAccountId",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "result": {
                    "oneof": ["response", "errorMessage"]
                  }
                }
              },
              "BulkRetrievePostedBalanceRequest": {
                "fields": {
                  "reportAccountIds": {
                    "type": ".squareup.balancereporter.ReportAccountId",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "effectiveAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "BulkRetrievePostedBalanceResponse": {
                "fields": {
                  "response": {
                    "type": ".squareup.balancereporter.service.BulkRetrievePostedBalanceResponse.Response",
                    "id": 1,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Response": {
                    "fields": {
                      "postedBalances": {
                        "type": ".squareup.balancereporter.service.BulkRetrievePostedBalanceResponse.Response.ReportAccountPostedBalance",
                        "id": 1,
                        "rule": "repeated"
                      }
                    },
                    "nested": {
                      "ReportAccountPostedBalance": {
                        "fields": {
                          "reportAccountId": {
                            "type": ".squareup.balancereporter.ReportAccountId",
                            "id": 1,
                            "rule": "optional"
                          },
                          "postedBalance": {
                            "type": ".squareup.connect.v2.common.Money",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              },
              "BalanceReporterService": {
                "methods": {
                  "GetBalanceReport": {
                    "requestType": ".squareup.balancereporter.service.GetBalanceReportRequest",
                    "responseType": ".squareup.balancereporter.service.GetBalanceReportResponse"
                  },
                  "GetBalanceReportItemDetails": {
                    "requestType": ".squareup.balancereporter.service.GetBalanceReportItemDetailsRequest",
                    "responseType": ".squareup.balancereporter.service.GetBalanceReportItemDetailsResponse"
                  },
                  "GetBalanceOverview": {
                    "requestType": ".squareup.balancereporter.service.GetBalanceOverviewRequest",
                    "responseType": ".squareup.balancereporter.service.GetBalanceOverviewResponse"
                  },
                  "BackfillMerchanteinMerchants": {
                    "requestType": ".squareup.balancereporter.service.BackfillMerchanteinMerchantsRequest",
                    "responseType": ".squareup.balancereporter.service.BackfillMerchanteinMerchantsResponse"
                  },
                  "SumUnitDebitCardSpend": {
                    "requestType": ".squareup.balancereporter.service.SumUnitDebitCardSpendRequest",
                    "responseType": ".squareup.balancereporter.service.SumUnitDebitCardSpendResponse"
                  },
                  "GetBalanceSnapshot": {
                    "requestType": ".squareup.balancereporter.service.GetBalanceSnapshotRequest",
                    "responseType": ".squareup.balancereporter.service.GetBalanceSnapshotResponse"
                  },
                  "BulkRetrievePostedBalance": {
                    "requestType": ".squareup.balancereporter.service.BulkRetrievePostedBalanceRequest",
                    "responseType": ".squareup.balancereporter.service.BulkRetrievePostedBalanceResponse"
                  },
                  "GetRolledUpActivity": {
                    "requestType": ".squareup.bizbank.service.GetRolledUpActivityRequest",
                    "responseType": ".squareup.bizbank.service.GetRolledUpActivityResponse"
                  }
                }
              },
              "ExternalBalanceReporterService": {
                "methods": {
                  "GetBalanceOverview": {
                    "requestType": ".squareup.balancereporter.service.GetBalanceOverviewRequest",
                    "responseType": ".squareup.balancereporter.service.GetBalanceOverviewResponse"
                  },
                  "GetBalanceReport": {
                    "requestType": ".squareup.balancereporter.service.GetBalanceReportRequest",
                    "responseType": ".squareup.balancereporter.service.GetBalanceReportResponse"
                  },
                  "GetBalanceReportItemDetails": {
                    "requestType": ".squareup.balancereporter.service.GetBalanceReportItemDetailsRequest",
                    "responseType": ".squareup.balancereporter.service.GetBalanceReportItemDetailsResponse"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.balancereporter?.nested?.service?.nested?.GetBalanceReportRequest && !$root.nested?.squareup?.nested?.balancereporter?.nested?.service?.nested?.GetBalanceReportRequest?.nested?.Filters && !$root.nested?.squareup?.nested?.balancereporter?.nested?.service?.nested?.GetBalanceReportRequest?.nested?.BatchRequest && !$root.nested?.squareup?.nested?.balancereporter?.nested?.service?.nested?.GetBalanceReportResponse && !$root.nested?.squareup?.nested?.balancereporter?.nested?.service?.nested?.GetBalanceReportResponse?.nested?.BalanceReportBundle && !$root.nested?.squareup?.nested?.balancereporter?.nested?.service?.nested?.GetBalanceReportResponse?.nested?.BalanceReportBundle?.nested?.DisplayData && !$root.nested?.squareup?.nested?.balancereporter?.nested?.service?.nested?.GetBalanceReportResponse?.nested?.BalanceReportLineItem && !$root.nested?.squareup?.nested?.balancereporter?.nested?.service?.nested?.GetBalanceReportItemDetailsRequest && !$root.nested?.squareup?.nested?.balancereporter?.nested?.service?.nested?.GetBalanceReportItemDetailsResponse && !$root.nested?.squareup?.nested?.balancereporter?.nested?.service?.nested?.GetBalanceOverviewRequest && !$root.nested?.squareup?.nested?.balancereporter?.nested?.service?.nested?.GetBalanceOverviewRequest?.nested?.Filters && !$root.nested?.squareup?.nested?.balancereporter?.nested?.service?.nested?.GetBalanceOverviewResponse && !$root.nested?.squareup?.nested?.balancereporter?.nested?.service?.nested?.BackfillMerchanteinMerchantsRequest && !$root.nested?.squareup?.nested?.balancereporter?.nested?.service?.nested?.BackfillMerchanteinMerchantsRequest?.nested?.VersionedMerchant && !$root.nested?.squareup?.nested?.balancereporter?.nested?.service?.nested?.BackfillMerchanteinMerchantsResponse && !$root.nested?.squareup?.nested?.balancereporter?.nested?.service?.nested?.SumUnitDebitCardSpendRequest && !$root.nested?.squareup?.nested?.balancereporter?.nested?.service?.nested?.SumUnitDebitCardSpendResponse && !$root.nested?.squareup?.nested?.balancereporter?.nested?.service?.nested?.GetBalanceSnapshotRequest && !$root.nested?.squareup?.nested?.balancereporter?.nested?.service?.nested?.GetBalanceSnapshotResponse && !$root.nested?.squareup?.nested?.balancereporter?.nested?.service?.nested?.GetBalanceSnapshotResponse?.nested?.Response && !$root.nested?.squareup?.nested?.balancereporter?.nested?.service?.nested?.BulkRetrievePostedBalanceRequest && !$root.nested?.squareup?.nested?.balancereporter?.nested?.service?.nested?.BulkRetrievePostedBalanceResponse && !$root.nested?.squareup?.nested?.balancereporter?.nested?.service?.nested?.BulkRetrievePostedBalanceResponse?.nested?.Response && !$root.nested?.squareup?.nested?.balancereporter?.nested?.service?.nested?.BulkRetrievePostedBalanceResponse?.nested?.Response?.nested?.ReportAccountPostedBalance && !$root.nested?.squareup?.nested?.balancereporter?.nested?.service?.nested?.BalanceReporterService && !$root.nested?.squareup?.nested?.balancereporter?.nested?.service?.nested?.ExternalBalanceReporterService) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE GetBalanceReportRequest @ squareup/balancereporter/service.proto at 20:1
 */
export const GetBalanceReportRequest = $root.lookupType('squareup.balancereporter.service.GetBalanceReportRequest');
fixType(GetBalanceReportRequest);
Builder.createAndAttachToType(GetBalanceReportRequest);
/**
 * SOURCE Filters @ squareup/balancereporter/service.proto at 21:3
 */
GetBalanceReportRequest.Filters = $root.lookupType('squareup.balancereporter.service.GetBalanceReportRequest.Filters');
fixType(GetBalanceReportRequest.Filters);
Builder.createAndAttachToType(GetBalanceReportRequest.Filters);
/**
 * SOURCE BatchRequest @ squareup/balancereporter/service.proto at 36:3
 */
GetBalanceReportRequest.BatchRequest = $root.lookupType('squareup.balancereporter.service.GetBalanceReportRequest.BatchRequest');
fixType(GetBalanceReportRequest.BatchRequest);
Builder.createAndAttachToType(GetBalanceReportRequest.BatchRequest);
/**
 * SOURCE GetBalanceReportResponse @ squareup/balancereporter/service.proto at 71:1
 */
export const GetBalanceReportResponse = $root.lookupType('squareup.balancereporter.service.GetBalanceReportResponse');
fixType(GetBalanceReportResponse);
Builder.createAndAttachToType(GetBalanceReportResponse);
/**
 * SOURCE BalanceReportBundle @ squareup/balancereporter/service.proto at 72:3
 */
GetBalanceReportResponse.BalanceReportBundle = $root.lookupType('squareup.balancereporter.service.GetBalanceReportResponse.BalanceReportBundle');
fixType(GetBalanceReportResponse.BalanceReportBundle, {
  id: {
    required: true
  }
});
Builder.createAndAttachToType(GetBalanceReportResponse.BalanceReportBundle);
/**
 * SOURCE DisplayData @ squareup/balancereporter/service.proto at 73:5
 */
GetBalanceReportResponse.BalanceReportBundle.DisplayData = $root.lookupType('squareup.balancereporter.service.GetBalanceReportResponse.BalanceReportBundle.DisplayData');
fixType(GetBalanceReportResponse.BalanceReportBundle.DisplayData);
Builder.createAndAttachToType(GetBalanceReportResponse.BalanceReportBundle.DisplayData);
/**
 * Balance report line item, either a bundle of individual items, or an unbundled item
 *
 * SOURCE BalanceReportLineItem @ squareup/balancereporter/service.proto at 98:3
 */
GetBalanceReportResponse.BalanceReportLineItem = $root.lookupType('squareup.balancereporter.service.GetBalanceReportResponse.BalanceReportLineItem');
fixType(GetBalanceReportResponse.BalanceReportLineItem);
Builder.createAndAttachToType(GetBalanceReportResponse.BalanceReportLineItem);
/**
 * SOURCE GetBalanceReportItemDetailsRequest @ squareup/balancereporter/service.proto at 117:1
 */
export const GetBalanceReportItemDetailsRequest = $root.lookupType('squareup.balancereporter.service.GetBalanceReportItemDetailsRequest');
fixType(GetBalanceReportItemDetailsRequest, {
  balanceReportItemId: {
    required: true
  }
});
Builder.createAndAttachToType(GetBalanceReportItemDetailsRequest);
/**
 * SOURCE GetBalanceReportItemDetailsResponse @ squareup/balancereporter/service.proto at 124:1
 */
export const GetBalanceReportItemDetailsResponse = $root.lookupType('squareup.balancereporter.service.GetBalanceReportItemDetailsResponse');
fixType(GetBalanceReportItemDetailsResponse, {
  detail: {
    required: true
  }
});
Builder.createAndAttachToType(GetBalanceReportItemDetailsResponse);
/**
 * SOURCE GetBalanceOverviewRequest @ squareup/balancereporter/service.proto at 129:1
 */
export const GetBalanceOverviewRequest = $root.lookupType('squareup.balancereporter.service.GetBalanceOverviewRequest');
fixType(GetBalanceOverviewRequest, {
  owner: {
    required: true
  },
  overviewType: {
    required: true
  },
  filters: {
    required: true
  }
});
Builder.createAndAttachToType(GetBalanceOverviewRequest);
/**
 * SOURCE Filters @ squareup/balancereporter/service.proto at 130:3
 */
GetBalanceOverviewRequest.Filters = $root.lookupType('squareup.balancereporter.service.GetBalanceOverviewRequest.Filters');
fixType(GetBalanceOverviewRequest.Filters, {
  beginAt: {
    required: true
  },
  endAt: {
    required: true
  }
});
Builder.createAndAttachToType(GetBalanceOverviewRequest.Filters);
/**
 * SOURCE GetBalanceOverviewResponse @ squareup/balancereporter/service.proto at 149:1
 */
export const GetBalanceOverviewResponse = $root.lookupType('squareup.balancereporter.service.GetBalanceOverviewResponse');
fixType(GetBalanceOverviewResponse);
Builder.createAndAttachToType(GetBalanceOverviewResponse);
/**
 * SOURCE BackfillMerchanteinMerchantsRequest @ squareup/balancereporter/service.proto at 156:1
 */
export const BackfillMerchanteinMerchantsRequest = $root.lookupType('squareup.balancereporter.service.BackfillMerchanteinMerchantsRequest');
fixType(BackfillMerchanteinMerchantsRequest);
Builder.createAndAttachToType(BackfillMerchanteinMerchantsRequest);
/**
 * SOURCE VersionedMerchant @ squareup/balancereporter/service.proto at 157:3
 */
BackfillMerchanteinMerchantsRequest.VersionedMerchant = $root.lookupType('squareup.balancereporter.service.BackfillMerchanteinMerchantsRequest.VersionedMerchant');
fixType(BackfillMerchanteinMerchantsRequest.VersionedMerchant, {
  version: {
    required: true
  },
  merchant: {
    required: true
  }
});
Builder.createAndAttachToType(BackfillMerchanteinMerchantsRequest.VersionedMerchant);
/**
 * SOURCE BackfillMerchanteinMerchantsResponse @ squareup/balancereporter/service.proto at 165:1
 */
export const BackfillMerchanteinMerchantsResponse = $root.lookupType('squareup.balancereporter.service.BackfillMerchanteinMerchantsResponse');
fixType(BackfillMerchanteinMerchantsResponse);
Builder.createAndAttachToType(BackfillMerchanteinMerchantsResponse);
/**
 * Sum all the card spend on debit card for a unit in the given time window.
 * Only includes completed transactions.
 *
 * SOURCE SumUnitDebitCardSpendRequest @ squareup/balancereporter/service.proto at 370:1
 */
export const SumUnitDebitCardSpendRequest = $root.lookupType('squareup.balancereporter.service.SumUnitDebitCardSpendRequest');
fixType(SumUnitDebitCardSpendRequest, {
  unitToken: {
    notEmpty: true
  },
  beginAt: {
    required: true
  },
  endAt: {
    required: true
  }
});
Builder.createAndAttachToType(SumUnitDebitCardSpendRequest);
/**
 * SOURCE SumUnitDebitCardSpendResponse @ squareup/balancereporter/service.proto at 383:1
 */
export const SumUnitDebitCardSpendResponse = $root.lookupType('squareup.balancereporter.service.SumUnitDebitCardSpendResponse');
fixType(SumUnitDebitCardSpendResponse);
Builder.createAndAttachToType(SumUnitDebitCardSpendResponse);
/**
 * SOURCE GetBalanceSnapshotRequest @ squareup/balancereporter/service.proto at 445:1
 */
export const GetBalanceSnapshotRequest = $root.lookupType('squareup.balancereporter.service.GetBalanceSnapshotRequest');
fixType(GetBalanceSnapshotRequest, {
  balanceSnapshotType: {
    required: true
  },
  reportAccountId: {
    required: true
  }
});
Builder.createAndAttachToType(GetBalanceSnapshotRequest);
/**
 * SOURCE GetBalanceSnapshotResponse @ squareup/balancereporter/service.proto at 450:1
 */
export const GetBalanceSnapshotResponse = $root.lookupType('squareup.balancereporter.service.GetBalanceSnapshotResponse');
fixType(GetBalanceSnapshotResponse);
Builder.createAndAttachToType(GetBalanceSnapshotResponse);
/**
 * SOURCE Response @ squareup/balancereporter/service.proto at 451:3
 */
GetBalanceSnapshotResponse.Response = $root.lookupType('squareup.balancereporter.service.GetBalanceSnapshotResponse.Response');
fixType(GetBalanceSnapshotResponse.Response);
Builder.createAndAttachToType(GetBalanceSnapshotResponse.Response);
/**
 * SOURCE BulkRetrievePostedBalanceRequest @ squareup/balancereporter/service.proto at 461:1
 */
export const BulkRetrievePostedBalanceRequest = $root.lookupType('squareup.balancereporter.service.BulkRetrievePostedBalanceRequest');
fixType(BulkRetrievePostedBalanceRequest, {
  reportAccountIds: {
    required: true
  },
  effectiveAt: {
    required: true
  }
});
Builder.createAndAttachToType(BulkRetrievePostedBalanceRequest);
/**
 * SOURCE BulkRetrievePostedBalanceResponse @ squareup/balancereporter/service.proto at 466:1
 */
export const BulkRetrievePostedBalanceResponse = $root.lookupType('squareup.balancereporter.service.BulkRetrievePostedBalanceResponse');
fixType(BulkRetrievePostedBalanceResponse, {
  response: {
    required: true
  }
});
Builder.createAndAttachToType(BulkRetrievePostedBalanceResponse);
/**
 * SOURCE Response @ squareup/balancereporter/service.proto at 467:3
 */
BulkRetrievePostedBalanceResponse.Response = $root.lookupType('squareup.balancereporter.service.BulkRetrievePostedBalanceResponse.Response');
fixType(BulkRetrievePostedBalanceResponse.Response);
Builder.createAndAttachToType(BulkRetrievePostedBalanceResponse.Response);
/**
 * SOURCE ReportAccountPostedBalance @ squareup/balancereporter/service.proto at 468:5
 */
BulkRetrievePostedBalanceResponse.Response.ReportAccountPostedBalance = $root.lookupType('squareup.balancereporter.service.BulkRetrievePostedBalanceResponse.Response.ReportAccountPostedBalance');
fixType(BulkRetrievePostedBalanceResponse.Response.ReportAccountPostedBalance, {
  reportAccountId: {
    required: true
  },
  postedBalance: {
    required: true
  }
});
Builder.createAndAttachToType(BulkRetrievePostedBalanceResponse.Response.ReportAccountPostedBalance);
/**
 * SOURCE BalanceReporterService @ squareup/balancereporter/service.proto at 479:1
 */
export const BalanceReporterService = $root.lookupService('squareup.balancereporter.service.BalanceReporterService');
/**
 * SOURCE ExternalBalanceReporterService @ squareup/balancereporter/service.proto at 501:1
 */
export const ExternalBalanceReporterService = $root.lookupService('squareup.balancereporter.service.ExternalBalanceReporterService');